/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import {
  FormSelect,
  FormTextInput,
  FormTextarea,
  FormRadioGroup,
  FormDatePicker
} from "protocol-setup/components/FormComponents";
import Select from "react-select";

import { FasTimes, FasSave } from "assets/icons";
import text from "protocol-setup/constants/text";
import { personsOptions, psrTypeOptions, sourceOptions, statusOptions, evaluationByGroupOptions } from "../Lovs";


export const PSRSelector = ({ psrList, selectedPSR, onPSRSelect }) => {
  const [disableSelector, setDisableSelector] = useState(false);

  const handleClearSelection = () => {
   setDisableSelector(!disableSelector);
    onPSRSelect("", null);
  };

  return (
    <div className="mb-4">
      <label className="color-dark-blue" htmlFor="psr-selector">
        {text.regulatory.psrForm.selectorLabel}
      </label>
      <div className="d-flex align-items-center">
        <div className="flex-grow-1">
          <Select
            inputId="psr-selector"
            value={psrList.find((psr) => psr.psrId === selectedPSR)}
            onChange={(selectedOption) => {
              const psrId = selectedOption ? selectedOption.psrId : "";
              const psrData = selectedOption || null;
              onPSRSelect(psrId, psrData);
              setDisableSelector(true);
            }}
            options={psrList}
            key={selectedPSR}
            isClearable={false}
            placeholder="Select..."
            className="reactSelect-wrapper"
            classNamePrefix="reactSelect"
            menuPortalTarget={document.body}
            getOptionValue={(option) => option.psrId}
            getOptionLabel={(option) => `${option?.description} (${option?.forVersionDate} | ${option?.psrType})`}
            isDisabled={disableSelector}
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999
              })
            }}
          />
        </div>
        {selectedPSR && (
          <button
            type="button"
            className="fn-btn close ml-3 d-flex align-items-center"
            onClick={handleClearSelection}
          >
          <FasTimes className="mr-1" />
            {text.regulatory.psrForm.changeSelectedPsrBtn}
          </button>
        )}
      </div>
    </div>
  );
};

export const PSRFormCore = ({
  selectedPSRChangeType,
  editMode,
  control,
  handleSubmit,
  onSubmit,
  handleCancel,
  isValid,
  isDirty,
  selectedPSR,
  today,
  setEditMode,
  trigger,
  hideFormActions,
  cardStyle = false
}) => {
  const shouldShowForm = selectedPSRChangeType === "newPSR" || selectedPSR;

  const handleAddPSR = (data, event) => {
    event.preventDefault();
    onSubmit(data);
  };

  const isSaveEnabled = () => {
    return !(isValid && isDirty);
  }
  
  return (
    <div className={`form-layout-wrapper ${editMode ? "edit-mode" : "read-only"}`}>
      <form>
        <div
          className={`${shouldShowForm ? "" : "d-none"} form-layout-body bg-white row ${
            cardStyle ? "shadow-sm p-4 rounded" : "px-0"
          } ${editMode ? "" : "pointer-events-none"}`}
        >
          <div className="invisible"></div>
          <ul className="col-6 mr-4">
            <li className="d-block form-sub-group-1">
              <div className="pb-1 mb-2">
                <FormTextInput
                  name="psrName"
                  section="regulatory"
                  form="psrForm"
                  control={control}
                  editMode={editMode}
                  required
                  trigger={trigger}
                />
              </div>
              <div className="pb-1 mb-2">
                <FormDatePicker
                  name="psrVersionDt"
                  section="regulatory"
                  form="psrForm"
                  control={control}
                  required
                  editMode={editMode}
                  type="text"
                  trigger={trigger}
                />
              </div>
              <div className="pb-1 mb-2">
                <FormSelect
                  name="psrType"
                  section="regulatory"
                  form="psrForm"
                  control={control}
                  options={psrTypeOptions}
                  required
                  placeholder="Select PSR Type"
                  className={editMode ? "" : "mb-3"}
                  readOnly={!editMode}
                  trigger={trigger}
                />
              </div>
              <div className="pb-1 mb-2">
                <FormDatePicker
                  name="psrRequiredByDt"
                  section="regulatory"
                  form="psrForm"
                  control={control}
                  placeholder=""
                  required
                  type="text"
                  minDate={selectedPSRChangeType === "newPSR" ? today : ""}
                  editMode={editMode}
                  trigger={trigger}
                />
              </div>
              <div className="pb-1 mb-2">
                <FormSelect
                  name="psrNumOfPersons"
                  section="regulatory"
                  form="psrForm"
                  control={control}
                  options={personsOptions}
                  required={false}
                  className={editMode ? "" : "mb-3"}
                  placeholder="Select"
                  readOnly={!editMode}
                />
              </div>
              <div className="pb-1 mb-2">
                <FormRadioGroup
                  name="isEvaluationByGroup"
                  section="regulatory"
                  form="psrForm"
                  control={control}
                  required
                  trigger={trigger}
                  options={evaluationByGroupOptions}
                />
              </div>
              <div className="pb-1 mb-2">
                <FormSelect
                  name="requestedStatus"
                  section="regulatory"
                  form="psrForm"
                  control={control}
                  options={statusOptions}
                  className={editMode ? "" : "mb-3"}
                  required
                  placeholder="Select Status"
                  readOnly={!editMode}
                  trigger={trigger}
                />
              </div>
            </li>
          </ul>
          <ul className="col-6">
            <li className="row form-sub-group d-block">
              <h3 className="content-group-title color-dark-blue mt-0">{text.regulatory.psrForm.processingInstructionsTitle}</h3>
              <div className="pb-1 mb-2">
                <FormSelect
                  name="sourceSubmittedBy"
                  section="regulatory"
                  form="psrForm"
                  control={control}
                  options={sourceOptions}
                  required
                  placeholder="Select sourceSubmittedBy"
                  readOnly={!editMode}
                  className={editMode ? "" : "mb-3"}
                  trigger={trigger}
                />
              </div>
              <div className="pb-1 mb-2">
                <FormTextarea
                  name="ctsuProcessingInstructions"
                  section="regulatory"
                  form="psrForm"
                  control={control}
                  rows={10}
                  readOnly={!editMode}
                  trigger={trigger}
                  required
                />
              </div>
              <div className="pb-1 mb-2">
                <FormTextarea name="psrComments" section="regulatory" form="psrForm" control={control} rows={3} trigger={trigger} />
              </div>
            </li>
            {/* Contact Information Section */}
            <li className="form-sub-group mt-8 d-block">
              <h3 className="content-group-title color-dark-blue mt-0">{text.regulatory.psrForm.contactInfoTitle}</h3>
              <div className="pb-1 mb-2">
                <FormTextInput name="psrContactName" section="regulatory" form="psrForm" control={control} required trigger={trigger} />
              </div>
              <div className="pb-1 mb-2">
                <FormTextInput name="psrContactPhoneNum" section="regulatory" form="psrForm" control={control} required trigger={trigger} />
              </div>
              <div className="pb-1 mb-2">
                <FormTextInput
                  name="psrContactEmailAddress"
                  section="regulatory"
                  form="psrForm"
                  control={control}
                  type="text"
                  required
                  trigger={trigger}
                />
              </div>
              <div className="pb-1 mb-2">
                <FormTextarea
                  name="psrDistributionList"
                  section="regulatory"
                  form="psrForm"
                  control={control}
                  rows={2}
                  readOnly={!editMode}
                />
              </div>
            </li>
            {selectedPSRChangeType === "copy" && (
              <li className="row form-sub-group mt-8 d-block">
                <h3 className="content-group-title color-dark-blue mt-0">{text.regulatory.psrForm.auditHistoryTitle}</h3>
                <div className="pb-1 mb-2">
                  <FormTextInput name="createdBy" section="regulatory" form="psrForm" control={control} disabled />
                </div>
                <div className="pb-1 mb-2">
                  <FormTextInput name="createdDt" section="regulatory" form="psrForm" control={control} disabled />
                </div>
                <div className="pb-1 mb-2">
                  <FormTextInput name="modifiedBy" section="regulatory" form="psrForm" control={control} disabled />
                </div>
                <div className="pb-1 mb-2">
                  <FormTextInput name="modifiedDt" section="regulatory" form="psrForm" control={control} disabled />
                </div>
              </li>
            )}
          </ul>
        </div>
        {!hideFormActions && (
          <div className="form-layout-footer">
            <div className="row mt-2 d-flex justify-content-center">
              {!editMode ? (
                <>
                  <button
                    type="button"
                    className="btn"
                    aria-label="Edit"
                    data-id="EDIT_BUTTON"
                    onClick={() => setEditMode(true)}
                    disabled={!selectedPSR}
                  >
                    {text.regulatory.psrForm.buttons.edit}
                  </button>
                  <button
                    type="button"
                    className="btn close mr-2 ml-2"
                    aria-label="Cancel"
                    data-id="CANCEL_BUTTON"
                    onClick={handleCancel}
                  >
                    {text.regulatory.psrForm.buttons.cancel}
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn "
                    aria-label="Save"
                    data-id="SAVE_BUTTON"
                    disabled={isSaveEnabled()}
                    onClick={handleSubmit((data, event) => handleAddPSR(data, event))}
                  >
                    <FasSave className="ml-n1"/>
                    {text.regulatory.psrForm.buttons.save}
                  </button>
                  <button
                    type="button"
                    className="btn close mr-2 ml-2"
                    aria-label="Cancel"
                    data-id="CANCEL_EDIT_BUTTON"
                    onClick={handleCancel}
                  >
                    {text.regulatory.psrForm.buttons.cancel}
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </form>
    </div>
  );
};
